import { IconProps } from "../../utils/global-types/global-types";

const LineArrowRightIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 13 12"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.219"
        d="M4.627 2.565h4.905V7.47M2.664 9.435l6.8-6.8"
      ></path>
    </svg>
  );
};

export default LineArrowRightIcon;
